// Shared canvas-texture factory. Many systems build a procedural texture the
// same way — make a canvas, get its 2D context, draw, wrap it in a CanvasTexture
// and set the colour space / wrap / anisotropy. This collapses that boilerplate
// into one place so the sRGB + anisotropy policy lives in a single spot.
//
// draw(ctx, canvas) paints the texture; opts tune the sampler:
//   colorSpace  THREE.SRGBColorSpace (default) — pass NoColorSpace for data
//               textures (bump/normal). Matches what each call site set before.
//   wrap        true → RepeatWrapping on S and T (default clamp).
//   anisotropy  number → set tex.anisotropy (default: leave at the renderer default).
//   repeat      [x, y] → tex.repeat.set(x, y).
// Returns the THREE.CanvasTexture.
import * as THREE from 'three';

export function makeCanvasTexture(w, h, draw, opts = {}) {
  const {
    colorSpace = THREE.SRGBColorSpace,
    wrap = false,
    anisotropy = 0,
    repeat = null,
  } = opts;
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  draw(ctx, canvas);
  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = colorSpace;
  if (wrap) tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
  if (anisotropy) tex.anisotropy = anisotropy;
  if (repeat) tex.repeat.set(repeat[0], repeat[1]);
  return tex;
}
